import { cn } from '@global/utils/tailwind'
import { ReactNode } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { DISABLED_HEADER_ROUTES } from 'routes'

interface MainProps {
  children: ReactNode
}

const isLiveEnvironment = process.env.PROXY_IS_LIVE_ENVIRONMENT

export const Main = ({ children }: MainProps) => {
  const location = useLocation()
  const isHeaderDisabled = DISABLED_HEADER_ROUTES.some(path =>
    matchPath(location.pathname, { path, exact: true }),
  )

  return (
    <main
      className={cn(
        isLiveEnvironment
          ? {
              'h-[calc(100vh_-_80px)]': !isHeaderDisabled,
              'h-[calc(100vh_-_40px)]': isHeaderDisabled,
            }
          : {
              'h-[calc(100vh_-_40px)]': !isHeaderDisabled,
              'h-screen': isHeaderDisabled,
            },
        'grow bg-[#FAFAFA]',
      )}
    >
      {children}
    </main>
  )
}
